import styled from 'styled-components'
// themes
import { colors } from 'themes/index'

export const SessionItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid ${colors.gray270};

  &:last-child {
    border-bottom: none;
  }
`

export const SessionInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const SessionDevice = styled.div`
  font-weight: bold;
  font-size: 16px;
  color: ${colors.darkBlue500};
`

export const SessionDetail = styled.div`
  font-size: 14px;
  color: ${colors.gray900};
`

export const CurrentBadge = styled.span`
  font-size: 13px;
  font-weight: bold;
  margin-left: 8px;
  background: ${colors.green500};
  color:  ${colors.white100};
  padding: 2px 8px;
  border-radius: 8px;
`
